function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css, keyframes } from '@emotion/react';
import { forwardRef } from 'react';
import { HubTooltip, InfoCircle } from '@arc/frontend/ui-common';
import { theme, typography } from '@arc/frontend/ui-theme';
import { ERROR_TRANSITION_FUNC, ERROR_TRANSITION_LENGTH } from '../Inputs';
const slideDown = keyframes({
  from: {
    transform: 'translateY(-110%)'
  },
  to: {
    transform: 'translateY(0)'
  }
});
const styles = {
  container: /*#__PURE__*/css(process.env.NODE_ENV === "production" ? "" : ";label:container;"),
  label: /*#__PURE__*/css(typography.label, "padding-left:0.75rem;margin-bottom:0.25rem;min-height:0.9rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:label;")),
  helperContainer: process.env.NODE_ENV === "production" ? {
    name: "14uhyoc",
    styles: "min-height:1rem"
  } : {
    name: "16buebt-helperContainer",
    styles: "min-height:1rem;label:helperContainer;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  helperText: /*#__PURE__*/css(typography.inputHelper, "font-size:12px;" + (process.env.NODE_ENV === "production" ? "" : ";label:helperText;")),
  helperTextAnimation: /*#__PURE__*/css({
    animation: `${slideDown} ${ERROR_TRANSITION_LENGTH} ${ERROR_TRANSITION_FUNC} forwards`
  }, process.env.NODE_ENV === "production" ? "" : ";label:helperTextAnimation;"),
  helperTextError: /*#__PURE__*/css({
    // tw`text-palettes-error-dark` doesn't work for some reason
    color: theme.colors.palettes.error.dark
  }, process.env.NODE_ENV === "production" ? "" : ";label:helperTextError;")
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "zjik7",
  styles: "display:flex"
} : {
  name: "1h2nn1l-formControl",
  styles: "display:flex;label:formControl;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "158icaa",
  styles: "margin-left:4px"
} : {
  name: "hb6evl-formControl",
  styles: "margin-left:4px;label:formControl;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
/**
 * Display a label and helper text around an input.
 */
export const FormControl = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function FormControl(props, ref) {
  const testid = props.error ? 'form-control-error' : 'form-control';
  const formControl = <div className={props.className} css={[styles.container, props.outerStyle, process.env.NODE_ENV === "production" ? "" : ";label:formControl;"]} data-testid={testid} ref={ref}>
				{props.label ? <div css={_ref}>
						<label css={[styles.label, props.labelStyle, process.env.NODE_ENV === "production" ? "" : ";label:formControl;"]}>{props.label}</label>
						{props.infoText ? <InfoCircle calloutText={props.infoText} size={14} css={_ref2} /> : null}
					</div> : null}

				<div css={props.innerStyle}>{props.children}</div>
				<div css={[styles.helperContainer, props.helperStyle, process.env.NODE_ENV === "production" ? "" : ";label:formControl;"]}>
					<div css={[styles.helperText, props.helperText && styles.helperTextAnimation, props.error && styles.helperTextError, props.helperTextStyle, process.env.NODE_ENV === "production" ? "" : ";label:formControl;"]}>
						{props.helperText ?? ''}
					</div>
					{props.helperExtra ? <div css={styles.label}>{props.helperExtra ?? ''}</div> : null}
				</div>
			</div>;
  if (props.tooltipText) {
    return <HubTooltip title={props.tooltipText}>{formControl}</HubTooltip>;
  }
  return formControl;
});